module.exports = __webpack_public_path__ + "static/Jellygon Logo White Large-966a2358ebbc8e08d9b636058080399b.png";